import { render } from "./OrderDepartureCustomsDetail.vue?vue&type=template&id=69b6c844&scoped=true&ts=true"
import script from "./OrderDepartureCustomsDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDepartureCustomsDetail.vue?vue&type=script&lang=ts"

import "./OrderDepartureCustomsDetail.vue?vue&type=style&index=0&id=69b6c844&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b6c844"]])

export default __exports__